import { useState } from "react";
import api, { formatApiError } from "@/lib/api";

export default function NewsletterSignup({ variant = "light" }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [status, setStatus] = useState({ state: "idle", msg: "" });

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus({ state: "loading", msg: "" });
    try {
      const { data } = await api.post("/subscribers", { email, name });
      setStatus({ state: "success", msg: data.message || "Subscribed." });
      setEmail(""); setName("");
    } catch (err) {
      setStatus({ state: "error", msg: formatApiError(err.response?.data?.detail) || err.message });
    }
  };

  const isDark = variant === "dark";

  return (
    <div
      data-testid="newsletter-signup"
      className={`rounded-3xl p-8 md:p-12 ${
        isDark
          ? "bg-[var(--rciq-navy)] text-white bg-dot-pattern"
          : "bg-[var(--rciq-bg-tint)] text-[var(--rciq-ink)] border border-[var(--rciq-line)]"
      }`}
    >
      <div className={`eyebrow ${isDark ? "eyebrow-light" : ""}`}>The Insights Newsletter</div>
      <h3 className={`font-serif-display text-3xl md:text-4xl font-700 mt-3 leading-tight tracking-tight ${isDark ? "text-white" : ""}`}>
        Stay Ahead of Revenue Cycle Trends
      </h3>
      <p className={`mt-4 max-w-2xl leading-relaxed ${isDark ? "text-white/75" : "text-[var(--rciq-ink-2)]"}`}>
        Subscribe to receive executive insights, industry trends, revenue cycle strategies,
        KPI guidance, denial management best practices, and AI innovations delivered directly
        to your inbox.
      </p>
      <form onSubmit={submit} className="mt-7 flex flex-col sm:flex-row gap-3 max-w-2xl">
        <input
          data-testid="newsletter-name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Name"
          className={`flex-1 rounded-full px-5 py-3.5 text-sm outline-none ${
            isDark
              ? "bg-white/10 text-white placeholder-white/50 border border-white/15 focus:border-[var(--rciq-teal)]"
              : "bg-white border border-[var(--rciq-line)] focus:border-[var(--rciq-teal)]"
          }`}
        />
        <input
          data-testid="newsletter-email"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email address"
          className={`flex-1 rounded-full px-5 py-3.5 text-sm outline-none ${
            isDark
              ? "bg-white/10 text-white placeholder-white/50 border border-white/15 focus:border-[var(--rciq-teal)]"
              : "bg-white border border-[var(--rciq-line)] focus:border-[var(--rciq-teal)]"
          }`}
        />
        <button
          data-testid="newsletter-submit"
          type="submit"
          disabled={status.state === "loading"}
          className="btn-pill btn-pill-primary text-[12px] justify-center"
        >
          {status.state === "loading" ? "Subscribing..." : "Subscribe"}
        </button>
      </form>
      {status.state === "success" && (
        <div data-testid="newsletter-success" className={`mt-4 text-sm ${isDark ? "text-[var(--rciq-teal)]" : "text-[var(--rciq-teal-dark)]"} font-600`}>
          ✓ {status.msg}
        </div>
      )}
      {status.state === "error" && (
        <div data-testid="newsletter-error" className="mt-4 text-sm text-red-400 font-600">{status.msg}</div>
      )}
    </div>
  );
}
